import { InternalPageId } from '#/service/constants/menu';

// TODO#paths: include all paths in this enum.
// switch to something like this later:
// https://github.com/adamziel/react-router-named-routes#react-router-40
export enum Path {
  Channels = '/channels',
  Registration = '/registration',
  ForgotPassword = '/forgotPassword',
  History = '/history',
  UpdatePassword = '/updatePassword',
  Readme = '/readme/:urlName',
  Settings = '/settings/:settingId',
  Search = '/search',
  Favorites = '/favorites',
  Subscribe = '/subscribe',
  Page = '/page/:pageId',
  Details = '/details/:pageId/:resourceType/:resourceId/*',
  Playback = '/playback/:resourceType/:resourceId',
  Gift = '/gift',
  Redeem = '/redeem',
  External = '/external/:paymentType/:result',
  AlternativePurchase = '/alternativePurchase',
  Home = '/',
  TveSecondScreenLogin = '/tve',
  SecondScreenLogin = '/tv',
}

export const destinationRoutes = {
  [InternalPageId.Register]: Path.Registration,
  [InternalPageId.WatchHistory]: Path.History,
  [InternalPageId.Search]: Path.Search,
  [InternalPageId.Favorites]: Path.Favorites,
  [InternalPageId.ProgramList]: Path.Channels,
  [InternalPageId.Settings]: Path.Settings,
  [InternalPageId.ForgotPassword]: Path.ForgotPassword,
};
